var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8372 14.4255C18.8734 14.2319 18.8158 14.0441 18.7323 13.8718L13.6891 5.80313C13.3923 5.32864 12.6084 5.32864 12.3116 5.80313L7.26843 13.8718C7.10569 14.1648 7.11961 14.5216 7.31286 14.7978L12.3561 21.3541C12.51 21.554 12.748 21.6715 13.0004 21.6715C13.2527 21.6715 13.4907 21.554 13.6447 21.3541L18.6879 14.7978C18.7534 14.6806 18.8257 14.5619 18.8372 14.4255ZM13.0004 7.76694L16.7903 13.8303L13.0004 14.9676L9.21042 13.8303L13.0004 7.76694ZM13.0004 19.526L10.1384 15.8055L12.7671 16.5941C12.9194 16.6402 13.0813 16.6402 13.2336 16.5941L15.8624 15.8055L13.0004 19.526Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.17188C6.72772 2.17188 1.625 7.2746 1.625 13.5469C1.625 19.8192 6.72772 24.9219 13 24.9219C19.2723 24.9219 24.375 19.8192 24.375 13.5469C24.375 7.2746 19.2723 2.17188 13 2.17188ZM13 23.2969C7.62354 23.2969 3.25 18.9233 3.25 13.5469C3.25 8.17041 7.62354 3.79688 13 3.79688C18.3765 3.79688 22.75 8.17041 22.75 13.5469C22.75 18.9233 18.3765 23.2969 13 23.2969Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.21c03f78a25f3a8f5d3130f18fee7d81.svg";
export { ForwardRef as ReactComponent };